import React, { useEffect, useState, useMemo } from "react";
import { LatoInstallation } from "../components/forms/Pergola_type";
import { useStoreSelector } from "../../../../../../hooks/StoreHooks";
import { TubolariChoice } from "./tubolariChoice";
import { Side, SideSelector } from "../components/side/side_selector";

const SIDE_TO_DIREZIONE: Record<Side, string> = {
  front: "Fronte",
  left: "Sinistra",
  back: "Retro",
  right: "Destra",
};

const EsteticaChoices: React.FC = () => {
  const [side, setSide] = useState<Side>("front");
  const lati = useStoreSelector(
    (store) => store.pergolaConfigurationBuilder.configuration?.dimensioni.lati
  );

  const isAddossato = (direzione: string) =>
    lati?.some((l) => l.direzione === direzione && l.tipo === LatoInstallation.addossato);

  const availableSides = useMemo<Side[]>(() => {
    const all: Side[] = ["front", "left", "back", "right"];
    return all.filter((s) => !isAddossato(SIDE_TO_DIREZIONE[s]));
  }, [lati]);

  useEffect(() => {
    if (!availableSides.includes(side) && availableSides.length > 0) {
      setSide(availableSides[0]);
    }
  }, [availableSides, side]);

  const sidesMap: Record<Side, JSX.Element> = {
    front: <TubolariChoice lato="Fronte"/>,
    left: <TubolariChoice lato='Sinistra'/>,
    right: <TubolariChoice lato='Destra'/>,
    back: <TubolariChoice lato='Retro'/>,
  };

  const currentSide = availableSides.includes(side) ? side : availableSides[0] ?? "front";

  return (
    <div>
      <SideSelector sides={availableSides} value={currentSide} onChange={setSide} />
      <div style={{ marginTop: 20 }}>
        {sidesMap[currentSide]}
      </div>
    </div>
  );
};

export default EsteticaChoices;
